export enum AppInfo {
  APP_VERSION = '2.82.0',
  FILE_VERSION = '2.3.0',
}
